@let selectedParameterValue = appClusterHtml.selectedParameter();
@let availableParametersValue = availableParameters();
@let isPigeonCustomerValue = isPigeonCustomer();
@let greenTableDesignValue = smwService.greenTableDesign();
@for (parameter of availableParametersValue; track $index) {
  <button
    mat-icon-button
    [ngClass]="
      parameter === selectedParameterValue
        ? 'parameter-button button-active'
        : 'parameter-button'
    "
    (click)="appClusterHtml.onChangeParameter(parameter)"
    [matTooltip]="'PRODUCT.SMW.OVERVIEW_PARAMETERS.' + parameter | translate">
    <ng-container
      appWmIcon
      [inputParameter]="parameter"
      [additionalClasses]="['ew-icon-size']"></ng-container>
  </button>
}
@if (webcamAvailable()) {
  <button
    mat-icon-button
    [ngClass]="
      selectedParameterValue === 'webcam'
        ? 'parameter-button button-active'
        : 'parameter-button'
    "
    (click)="appClusterHtml.onChangeParameter('webcam')"
    [matTooltip]="'PRODUCT.SMW.OVERVIEW_PARAMETERS.webcam' | translate">
    <ng-container
      appWmIcon
      [inputParameter]="'webcam'"
      [additionalClasses]="['ew-icon-size']"></ng-container>
  </button>
}
&nbsp;
<span class="smw-map-card__selected-parameter-title">{{
  'PRODUCT.SMW.OVERVIEW_PARAMETERS.' + selectedParameterValue | translate
}}</span>
<hr class="smw-map-card__seperator" />

<app-cluster-html
  #appClusterHtml
  [style]="'mapbox://styles/' + activeMapLayerStyle()"
  [bounds]="bounds()"
  [mapLayers]="mapLayers"
  [activeMapLayerName]="activeMapLayerName()"
  (setActiveMapLayerByName)="setActiveMapLayerByName($event)"
  (mapLoad)="onMapLoad($event)"
  [data]="data()"
  [tabParameters]="clusterTabParameters()"
  [getMarkerColorClassFn]="boundGetMarkerColorClassFn()"
  [getGmaAlarmMarkerColorFn]="boundGetGmaAlarmMarkerColorFn()"
  [webcamImages]="webcamImages()">
  <ng-container popup>
    @let selectedStationValue = appClusterHtml.selectedStation();
    <mat-card-header>
      <mat-card-title>{{
        selectedStationValue?.properties.name
      }}</mat-card-title>
      <mat-card-subtitle>
        <fa-icon
          [icon]="[
            'far',
            selectedStationValue?.properties | stationIconMap,
          ]"></fa-icon>
        &nbsp;
        {{
          selectedStationValue?.properties?.['dtg']
            | datex
              : 'dd DD.MM. HH:mm'
              : undefined
              : languageService.langSignal()
        }}
      </mat-card-subtitle>
    </mat-card-header>
    @if (!!selectedStationValue?.properties?.webcam) {
      <img
        mat-card-image
        [src]="selectedStationValue?.properties?.webcam"
        (click)="onWebcamClick()"
        alt="Webcam" />
    }
    @if (!!selectedStationValue) {
      <table class="station-card-basic__table" cellpadding="2" cellspacing="0">
        @for (key of selectedStationValue.properties | key; track $index) {
          @if (
            (key | isAvailableParameter: availableParametersValue) &&
            !!selectedStationValue.properties[key]
          ) {
            <tr>
              <td
                [attr.align]="'center'"
                [matTooltip]="
                  'PRODUCT.SMW.OVERVIEW_PARAMETERS.' + key | translate
                ">
                <ng-container appWmIcon [inputParameter]="key"></ng-container>
              </td>
              @if (key === 'tt' || key === 'road_tt') {
                <td
                  [attr.align]="'right'"
                  [ngClass]="
                    key
                      | getMarkerColorClass
                        : selectedStationValue.properties[key]
                        : isPigeonCustomerValue
                        : greenTableDesignValue
                  ">
                  {{ selectedStationValue.properties[key] | number: '1.1-1' }}
                  °C
                </td>
              } @else if (key === 'road_condition') {
                <td
                  [attr.align]="'right'"
                  [ngClass]="
                    key
                      | getMarkerColorClass
                        : selectedStationValue.properties[key]
                        : isPigeonCustomerValue
                        : greenTableDesignValue
                  ">
                  {{
                    'MAPPING.GMA_ROAD_CONDITION.' +
                      selectedStationValue.properties[key] | translate
                  }}
                </td>
              } @else if (key === 'gmaAlarm') {
                <td
                  [attr.align]="'right'"
                  [ngStyle]="{
                    backgroundColor:
                      selectedStationValue.properties[key] | getGmaAlarmColor,
                    color: 'white',
                  }">
                  {{
                    'PRODUCT.SMW.Alarm.' +
                      smwService.gmaAlarmText[
                        selectedStationValue.properties[key]
                      ] | translate
                  }}
                </td>
              } @else if (key === 'vv') {
                <td
                  [attr.align]="'right'"
                  [ngClass]="
                    key
                      | getMarkerColorClass
                        : selectedStationValue.properties[key]
                        : isPigeonCustomerValue
                        : greenTableDesignValue
                  ">
                  {{ selectedStationValue.properties[key] / 1000 | round }}
                  km
                </td>
              } @else if (key === 'ww') {
                <td [attr.align]="'right'">
                  {{
                    'MAPPING.WW.' +
                      (selectedStationValue.properties[key] | round) | translate
                  }}
                </td>
              } @else if (key === 'ff' || key === 'fx') {
                <td
                  [attr.align]="'right'"
                  [ngClass]="
                    key
                      | getMarkerColorClass
                        : selectedStationValue.properties[key]
                        : isPigeonCustomerValue
                        : greenTableDesignValue
                  ">
                  {{ selectedStationValue.properties[key] * 1.852 | round }}
                  km/h
                </td>
              } @else if (key === 'n' || key === 'nlow') {
                <td [attr.align]="'right'">
                  {{ selectedStationValue.properties[key] | round }}/8
                </td>
              } @else if (key === 'rh') {
                <td
                  [attr.align]="'right'"
                  [ngClass]="
                    key
                      | getMarkerColorClass
                        : selectedStationValue.properties[key]
                        : isPigeonCustomerValue
                        : greenTableDesignValue
                  ">
                  {{ selectedStationValue.properties[key] | round }}
                  %
                </td>
              } @else if (key === 'hcl') {
                <td
                  [attr.align]="'right'"
                  [ngClass]="
                    key
                      | getMarkerColorClass
                        : selectedStationValue.properties[key]
                        : isPigeonCustomerValue
                        : greenTableDesignValue
                  ">
                  {{ selectedStationValue.properties[key] | round }}
                  m
                </td>
              } @else if (key === 'td') {
                <td
                  [attr.align]="'right'"
                  [ngClass]="
                    key
                      | getMarkerColorClass
                        : selectedStationValue.properties[key]
                        : isPigeonCustomerValue
                        : greenTableDesignValue
                  ">
                  {{ selectedStationValue.properties[key] | number: '1.1-1' }}
                  °C
                </td>
              } @else {
                <td [attr.align]="'right'">
                  @if (key !== 'gmaAlarm') {
                    {{
                      selectedStationValue.properties[key] | number: '1.1-1'
                    }}°C
                  }
                </td>
              }
            </tr>
          }
        }
      </table>
    }
    <mat-card-actions style="justify-content: center">
      <button
        mat-icon-button
        [matTooltip]="'PRODUCT.SMW.TABLE' | translate"
        (click)="
          navigateToStationView.emit({
            station: selectedStationValue?.properties?.stationId,
            tab: 2,
          })
        ">
        <fa-icon [icon]="['far', 'th']" transform="shrink-4"></fa-icon>
      </button>
      <button
        mat-icon-button
        [matTooltip]="'PRODUCT.SMW.METEOGRAM' | translate"
        (click)="
          navigateToStationView.emit({
            station: selectedStationValue?.properties?.stationId,
            tab: 3,
          })
        ">
        <fa-icon [icon]="['far', 'analytics']" transform="shrink-4"></fa-icon>
      </button>
      @let hasUserEppValue =
        selectedStationValue?.properties?.stationId
          | hasUserEpp
            : auth.isMaster()
            : auth.getCustomerAlias()
            : auth.getCustomerDocument()
            : auth.hasUserWebAccess()
            : auth.getUserProfile()?.['metadata']
            : false;
      @if (hasUserEppValue) {
        <button
          mat-icon-button
          [routerLink]="['/epp', selectedStationValue?.properties?.stationId]"
          [matTooltip]="'PRODUCT.EPP.TITLE' | translate">
          <fa-icon
            [icon]="['far', 'clouds-sun']"
            transform="shrink-4"></fa-icon>
        </button>
      }
    </mat-card-actions>
  </ng-container>
</app-cluster-html>
